import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
export var StepperContent = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\nmax-height: calc(100vh - 200px);\noverflow-y: auto;\ndisplay: ", ";\n"], ["\nmax-height: calc(100vh - 200px);\noverflow-y: auto;\ndisplay: ", ";\n"])), isIE11 ? 'block !important' : 'flex');
export default StepperContent;
var templateObject_1;
//# sourceMappingURL=StepperContent.js.map


// WEBPACK FOOTER //
// ../../../src/components/stepper/StepperContent.tsx